export enum ProductGroupContentsType {
  BEST_PRODUCTS = 'BEST_PRODUCTS',
  ZIGZIN_PRODUCTS = 'ZIGZIN_PRODUCTS',
  COLLECTION = 'COLLECTION',
  NEWEST_PRODUCTS = 'NEWEST_PRODUCTS',
  RELATED_PRODUCTS = 'RELATED_PRODUCTS',
}

export const getObjectSection = (contents_type: string) => {
  switch (contents_type) {
    case ProductGroupContentsType.BEST_PRODUCTS:
      return 'best';
    case ProductGroupContentsType.ZIGZIN_PRODUCTS:
      return 'zonly';
    case ProductGroupContentsType.NEWEST_PRODUCTS:
      return 'new';
    case ProductGroupContentsType.RELATED_PRODUCTS:
      return 'related';
  }
};
